import type { CustomSessionOptionType } from 'bundles/enterprise-admin-drawers/components/types';
import type {
  EnterpriseAdminSessionSelectionOptionType,
  EnterpriseAdminSessionSelectionOptionTypeExternallyManagedSessionOption,
  EnterpriseAdminSessionSelectionOptionTypePrivateSessionGroupOption,
} from 'bundles/naptimejs/resources/__generated__/EnterpriseProductConfigurationsV1';

export const assertIsExternallyManagedOption = (
  sessionOption: EnterpriseAdminSessionSelectionOptionType | CustomSessionOptionType | undefined
): sessionOption is EnterpriseAdminSessionSelectionOptionTypeExternallyManagedSessionOption => {
  return sessionOption?.typeName === 'externallyManagedSessionOption';
};

export const assertIsPrivateOption = (
  sessionOption: EnterpriseAdminSessionSelectionOptionType | CustomSessionOptionType | undefined
): sessionOption is EnterpriseAdminSessionSelectionOptionTypePrivateSessionGroupOption => {
  return sessionOption?.typeName === 'privateSessionGroupOption';
};

export const assertIsSessionOptionWithSessionId = (
  sessionOption: EnterpriseAdminSessionSelectionOptionType | CustomSessionOptionType | undefined
): sessionOption is
  | EnterpriseAdminSessionSelectionOptionTypePrivateSessionGroupOption
  | EnterpriseAdminSessionSelectionOptionTypeExternallyManagedSessionOption => {
  return assertIsExternallyManagedOption(sessionOption) || assertIsPrivateOption(sessionOption);
};
